/* eslint-disable no-template-curly-in-string */
/* eslint-disable jsx-a11y/anchor-is-valid */


import React, { Component } from 'react';

import { Editor, EditorState, Modifier, ContentState, CompositeDecorator } from 'draft-js';
import { decorators } from './utils/decorators';

import 'draft-js/dist/Draft.css';
import { EditableRecipient } from '../StyledEditables';











class EditableBlock extends Component {
  editor = null;

  constructor(props) {
    super(props);

    const { value } = props;
    const editorState = value ?
    EditorState.createWithContent(
      ContentState.createFromText(this.modifyText(value))
    ) :
    EditorState.createEmpty();
    this.state = { editorState };
  }

  componentDidMount() {
    const { editorState } = this.state;
    const { value } = this.props;
    const updateWithDecorator = EditorState.set(editorState, {
      decorator: new CompositeDecorator(decorators)
    });

    if (value) {
      this.setState({
        editorState: EditorState.moveFocusToEnd(updateWithDecorator)
      });
    }
  }

  modifyText = (value) => value.
  replace(/\$\{recipientName\}/g, '<Recipient Name>').
  replace(/\$\{recipientCompany\}/g, '<Company Name>');

  setEditor = (editor) => {
    this.editor = editor;
  };

  focusEditor = () => {
    if (this.editor) {
      this.editor.focus();
    }
  };

  onEditorStateChange = (editorState) => {
    const { onChange } = this.props;
    this.setState({ editorState }, () => {
      const plainText = editorState.getCurrentContent().getPlainText();
      onChange(
        plainText.
        replace(/<Recipient Name>/g, '${recipientName}').
        replace(/<Company Name>/g, '${recipientCompany}')
      );
    });
  };

  insertText = (editorState, type) => {
    const currentContent = editorState.getCurrentContent();
    const currentSelection = editorState.getSelection();
    if (type === 'recipient') {
      const newContent = Modifier.replaceText(
        currentContent,
        currentSelection,
        '<Recipient Name>'
      );
      const newEditorState = EditorState.push(editorState, newContent, 'insert-characters');
      return EditorState.forceSelection(newEditorState, newContent.getSelectionAfter());
    }
    const newContent = Modifier.replaceText(
      currentContent,
      currentSelection,
      '<Company Name>'
    );
    const newEditorState = EditorState.push(editorState, newContent, 'insert-characters');
    return EditorState.forceSelection(newEditorState, newContent.getSelectionAfter());
  };

  insertPlaceholder = (type) => {
    const { editorState } = this.state;
    const { onChange } = this.props;
    this.setState({ editorState: this.insertText(editorState, type) }, () => {
      const { editorState: updatedEditorState } = this.state;
      this.focusEditor();
      const plainText = updatedEditorState.getCurrentContent().getPlainText();
      if (type === 'recipient') {
        onChange(plainText.replace(/<Recipient Name>/g, '${recipientName}'));
      } else {
        onChange(plainText.replace(/<Company Name>/g, '${recipientCompany}'));
      }
    });
  };

  render() {
    const { editorState } = this.state;
    const {
      setButtonRef,
      style,
      computedStyle,
      isVisible,
      className
    } = this.props;

    return (
      <EditableRecipient
        className={className}
        style={style}
        computedStyle={computedStyle}
        isVisible={isVisible}>

        <Editor
          ref={this.setEditor}
          editorState={editorState}
          onChange={this.onEditorStateChange} />

        <button
          ref={(node) => setButtonRef('recipient', node)}
          style={{ display: 'none' }}
          type="button"
          onClick={() => this.insertPlaceholder('recipient')} />

        <button
          ref={(node) => setButtonRef('company', node)}
          style={{ display: 'none' }}
          type="button"
          onClick={() => this.insertPlaceholder('company')} />

      </EditableRecipient>);

  }
}

export default EditableBlock;